export const FETCH_SITES = "FETCH_SITES"
export const FETCH_SITES_REQUEST = "FETCH_SITES_REQUEST"
export const FETCH_SITES_SUCCESS = "FETCH_SITES_SUCCESS"
export const FETCH_SITES_FAILURE = "FETCH_SITES_FAILURE"
export const RESET_SITE_SEARCH = "RESET_SITE_SEARCH"
export const SHOW_RESULTS = "SHOW_RESULTS"



export const NOTE = {
  ID: 'id',
  NOTE_TEXT: 'note',
  IS_READ: 'is_read',
  IS_EDITABLE: 'is_editable',
  USER: 'name'
};
